
export default [
    // signup route with optional refererral link
    {
        path: '/sms',
        name: 'sms.index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/sms/index.vue'),
        meta: {
            layout: 'dashboard'
        },
        children: [
            {
                path: '',
                name: 'sms.index',
                component: () => import(/* webpackChunkName: "about" */ '@/views/sms/quicksms.vue'),
                meta: {
                    layout: 'dashboard'
                }
            }
        ]
    }
]
